import React from 'react';

import { Heading } from '@uk-source-web/heading';
import { Icon } from '@uk-source-web/icon';
import { Paragraph } from '@uk-source-web/paragraph';
import TextInputWithLabel from '@uk-source-web/text-input-with-label';
import { Button } from '@uk-source-web/button';
import {
  NextStepHeading,
  TenantPortingButtons,
  TenantPortingCallout,
  TenantPortingContent,
  TenantPortingItem,
  TenantPortingList,
  TenantPortingTextInput,
} from './TenantPortingNextStep.styles';
import { TenantPortingNextStepsProps } from './TenantPortingNextSteps.types';

const TenantPortingNextSteps = ({
  messageHeading,
  adminMessage,
  adminTenantPortingItems,
  notAdminMessage,
  notAdminTenantPortingItems,
  accesssButton,
  copyLinkButton,
}: TenantPortingNextStepsProps) => {
  const [value, setValue] = React.useState('');


//   useEffect(() => {
//   // simulate API response
//   const apiUrl = response?.tpURL; 
//   setValue(apiUrl);
// }, [response]);

const handleCopyLink = async () => {
  if (!value) return;

  try {
    await navigator.clipboard.writeText(value);
    console.log('Copied:', value);
  } catch (err) {
    console.error('Failed to copy:', err);
  }
};
  return (
    <>
      <NextStepHeading>
        <Heading level={4} weight={3}>
          {messageHeading}
        </Heading>
      </NextStepHeading>
      <TenantPortingCallout>
        <TenantPortingContent>
          <Icon name={'tick-circle'} group="system" />
          <Paragraph size={2} weight={3} justify="center">
            {adminMessage}
          </Paragraph>
        </TenantPortingContent>
        <TenantPortingList>
          {adminTenantPortingItems.map(item => (
            <TenantPortingItem key={item.name}>{item.label}</TenantPortingItem>
          ))}
        </TenantPortingList>
        <TenantPortingContent>
          <Icon name={'error-circle'} group="system" />
          <Paragraph size={2} weight={3} justify="center">
            {notAdminMessage}
          </Paragraph>
        </TenantPortingContent>
        <TenantPortingList>
          {notAdminTenantPortingItems.map(item => (
            <TenantPortingItem key={item.name}>{item.label}</TenantPortingItem>
          ))}
        </TenantPortingList>
      </TenantPortingCallout>
      <TenantPortingTextInput>
        <TextInputWithLabel
          id="defaultTextInput"
          textInput={{
            id: '',
            type: 'text',
            placeholder: 'https://admin.microsoft.com/Adminportal/',
            value: value,
            onChange: e => setValue(e.target.value),
          }}
          fieldWrapper={{
            label: '',
            width: 'default',
          }}
        />
      </TenantPortingTextInput>
      <TenantPortingButtons>
        <Button
          id="completed-purchase-vodafone"
          text={accesssButton?.label}
           onClick={handleCopyLink}
          icon={
            accesssButton?.iconRef
              ? {
                  name: accesssButton?.iconRef,
                  justify: 'right',
                }
              : undefined
          }
          appearance="secondary"
        />
        <Button
          id="completed-purchase-vodafone"
          text={copyLinkButton?.label}
          href={copyLinkButton?.url}
          icon={
            copyLinkButton?.iconRef
              ? {
                  name: copyLinkButton?.iconRef,
                  justify: 'right',
                }
              : undefined
          }
          appearance="secondary"
        />
      </TenantPortingButtons>
    </>
  );
};

export default TenantPortingNextSteps;
